import { ConditionRegistryCategory } from '../../../registry/condition/ConditionRegistryCategory';
export class ConditionsMultiSelectOption extends ConditionRegistryCategory {
    label = 'Multi Select Option';
    constructor(parent) {
        super(parent);
        super.init();
    }
}
